// This describes the current downloadable news records, not every article or
// the whole atlas. Source material retains its original publisher's rights.
export const newsDatasetSchema = {
  '@context': 'https://schema.org',
  '@type': 'Dataset',
  '@id': 'https://www.omikina.com/datasets#news-edition',
  name: 'OMIKINA Current Source-Linked News Edition',
  description: 'The current rolling OMIKINA news edition: publisher headlines, source URLs, publication times, pipeline categories, and industry-effect tags. These discovery records are not independent verification of publisher claims.',
  url: 'https://www.omikina.com/datasets',
  creator: { '@type': 'Organization', '@id': 'https://www.omikina.com/#organization', name: 'OMIKINA', url: 'https://www.omikina.com/' },
  isAccessibleForFree: true,
  inLanguage: 'en-US',
  distribution: [{ '@type': 'DataDownload', contentUrl: 'https://www.omikina.com/api/news', encodingFormat: 'application/json' }],
  variableMeasured: ['Publisher headline', 'Publisher', 'Source URL', 'Publication time', 'Pipeline categories', 'Industry-effect tags'],
}

export function datasetSchemaForCanonical(canonical: string) {
  return canonical === newsDatasetSchema.url ? newsDatasetSchema : undefined
}
